import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// SEC — CSRF double-submit: read csrf_token cookie and echo it back in
// X-CSRF-Token on every state-changing request. The backend middleware
// requires header==cookie for POST/PUT/PATCH/DELETE on /api/*.
function readCookie(name) {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/[.*+?^${}()|[\\]\\\\]/g, "\\\\$&") + "=([^;]*)"));
  return match ? decodeURIComponent(match[1]) : null;
}

api.interceptors.request.use((config) => {
  const method = (config.method || "get").toUpperCase();
  if (method !== "GET" && method !== "HEAD" && method !== "OPTIONS") {
    const token = readCookie("csrf_token");
    if (token) {
      config.headers = config.headers || {};
      config.headers["X-CSRF-Token"] = token;
    }
  }
  return config;
});

// One-time auto-retry when the very first mutation fires before the CSRF
// cookie exists. The backend still sets the cookie on the 403 response, so
// the retry (with header now populated) succeeds transparently.
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const config = error.config || {};
    const status = error.response?.status;
    const detail = error.response?.data?.detail;
    const isCsrf = status === 403 && typeof detail === "string" && detail.toLowerCase().includes("csrf");
    if (isCsrf && !config.__csrfRetried) {
      config.__csrfRetried = true;
      const token = readCookie("csrf_token");
      if (token) {
        config.headers = config.headers || {};
        config.headers["X-CSRF-Token"] = token;
        return api.request(config);
      }
    }
    return Promise.reject(error);
  }
);

// Format FastAPI error `detail` (string or array of {msg}) into a readable string.
export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
